import React from "react";
import { FaBan, FaCheck, FaTimes, FaUnlock } from "react-icons/fa";

const UserLogsTab = ({
  miniTab,
  setMiniTab,
  users,
  pendingUsers,
  blockedUsers,
  declinedUsers,
  activityLogs,
  blockUser,
  approveUser,
  declineUser,
  unblockUser,
}) => {
  return (
    <div className="user-logs">
      <div className="mini-tabs">
        <button
          className={miniTab === "ApprovedUsers" ? "active" : ""}
          onClick={() => setMiniTab("ApprovedUsers")}
        >
          Approved Users <span className="bubble">{users.length}</span>
        </button>
        <button
          className={miniTab === "PendingUsers" ? "active" : ""}
          onClick={() => setMiniTab("PendingUsers")}
        >
          Pending Users{" "}
          <span className="bubble">{pendingUsers.length}</span>
        </button>
        <button
          className={miniTab === "BlockedUsers" ? "active" : ""}
          onClick={() => setMiniTab("BlockedUsers")}
        >
          Blocked Users{" "}
          <span className="bubble">{blockedUsers.length}</span>
        </button>
        <button
          className={miniTab === "DeclinedUsers" ? "active" : ""}
          onClick={() => setMiniTab("DeclinedUsers")}
        >
          Declined Users{" "}
          <span className="bubble">{declinedUsers.length}</span>
        </button>
        <button
          className={miniTab === "UserActivities" ? "active" : ""}
          onClick={() => setMiniTab("UserActivities")}
        >
          User Activities
        </button>
      </div>
      {miniTab === "ApprovedUsers" && (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {[
              ...users.filter((user) => user.role === "admin"),
              ...users
                .filter((user) => user.role !== "admin")
                .reverse(),
            ].map((user) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.email}</td>
                <td>{user.role}</td>
                <td>
                  <FaBan
                    className="block-icon"
                    onClick={() => blockUser(user)}
                    style={{
                      color: "red",
                      cursor: "pointer",
                      fontSize: "1.5em",
                      transition: "color 0.3s ease",
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {miniTab === "PendingUsers" && (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pendingUsers
              .slice()
              .reverse()
              .map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td>
                    <div className="icon-container">
                      <FaCheck
                        className="approve-icon"
                        onClick={() => approveUser(user)}
                        style={{
                          color: "green",
                          cursor: "pointer",
                          fontSize: "1.5em",
                          transition: "color 0.3s ease",
                        }}
                      />
                      <FaTimes
                        className="decline-icon"
                        onClick={() => declineUser(user.id)}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          fontSize: "1.5em",
                          transition: "color 0.3s ease",
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
      {miniTab === "BlockedUsers" && (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {blockedUsers
              .slice()
              .reverse()
              .map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td>
                    <button onClick={() => unblockUser(user)}>
                      <FaUnlock style={{ color: "#00c04b" }} />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
      {miniTab === "DeclinedUsers" && (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {declinedUsers
              .slice()
              .reverse()
              .map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td>
                    <FaCheck
                      onClick={() => approveUser(user)}
                      style={{
                        color: "green",
                        cursor: "pointer",
                        fontSize: "1.5em",
                        transition: "color 0.3s ease",
                      }}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
      {miniTab === "UserActivities" && (
        <table>
          <thead>
            <tr>
              <th>Email</th>
              <th>Activity</th>
              <th>Product Name (Product Code)</th>
              <th>Date, Time</th>
            </tr>
          </thead>
          <tbody>
            {activityLogs
              .sort(
                (a, b) => new Date(b.changed_at) - new Date(a.changed_at)
              )
              .map((log, index) => (
                <tr key={index}>
                  <td>{log.email}</td>
                  <td>{log.action_type}</td>
                  <td>{log.product_code}</td>
                  <td>{new Date(log.changed_at).toLocaleString('en-US', { timeZone: 'UTC' })}</td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserLogsTab;
